// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"clinical-portal-3__RecordingAlert__wrapper","alert":"clinical-portal-3__RecordingAlert__alert"};